module.exports = __webpack_public_path__ + "images/8dab2cec87261dfd5eb30c099c8e064d.png";